const buildFleetEventsRequestPayload = ({
  registrationNumber,
  timeBegin,
  timeEnd,
  timezone,
  locale,
  rows,
  page,
  hasSecondaryEngine
}) => ({
  registration_num: registrationNumber,
  timeBegin,
  timeEnd,
  timezone,
  tz: timezone,
  locale,
  rows,
  page,
  sidx: 'eventDate',
  sord: 'asc',
  // The events report must honor the requested page. Asking the upstream
  // report service for the last page can cause every page request to return
  // the same rows.
  showLastPage: false,
  profileSecondaryEngine: hasSecondaryEngine
});

export default buildFleetEventsRequestPayload;
